import { render, staticRenderFns } from "./Startseite ERP.vue?vue&type=template&id=2a74e353"
import script from "./Startseite ERP.vue?vue&type=script&lang=js"
export * from "./Startseite ERP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports